import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import DocumentViewModel from '../ViewModels/DocumentViewModel';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import IconButton from '@material-ui/core/IconButton';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

interface IDocumentUploadBasketRowProps {
    index: number;
    document: DocumentViewModel;
    removeDocument: (document: DocumentViewModel) => void;
}

interface IDocumentUploadBasketRowState {
}

class DocumentUploadBasketRow extends Component<IDocumentUploadBasketRowProps & WithStyles<typeof styles>, IDocumentUploadBasketRowState> {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
    }

    public render() {

        return (
            <React.Fragment>
                {this.props.document !== undefined && this.props.document.document !== undefined &&
                    <TableRow key={'basketRow' + this.props.index}>
                        <TableCell>
                            {this.props.document.document?.name}
                        </TableCell>
                        <TableCell>
                            {(this.props.document.document?.size / 1048576).toFixed(2).toString() + 'Mb'}
                        </TableCell>
                        <TableCell>
                            {this.props.document.documentTypeText}
                        </TableCell>
                        <TableCell>
                            <IconButton onClick={this.delete}>
                                <DeleteForeverIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                }
            </React.Fragment>
        );
    }

    public delete = () => {
        this.props.removeDocument(this.props.document);
    }

}

export default withStyles(styles)(DocumentUploadBasketRow);

